import Accordion from './Accordions';

export default Accordion;
